import { isArnoldBrosRewardBands } from './rewardBandsUtils';

const isPointsToPayConversionReward = ({
  reward,
}: {
  reward: BonusTypes.Rewards.AnyRewardOutput;
}): boolean => {
  if (reward.type !== 'fixedBanded' && reward.type !== 'multiplierBanded') {
    return false;
  }

  const { rewardBands } = reward;
  if (!rewardBands || isArnoldBrosRewardBands(rewardBands)) {
    return false;
  }

  return rewardBands.field === 'totalPoints';
};

export default isPointsToPayConversionReward;
